import { createApiSlice } from 'app/createApiSlice'
import {
  API_SHARED_GROUPS,
  API_SHARED_GROUP_FARMERS,
  API_SHARED_GROUP_FARMER_SUMMARY,
  API_SHARED_GROUP_MANAGEMENT,
  API_SHARED_GROUP_MANAGEMENT_COUNT,
  API_SHARED_GROUP_LANDPLOT,
  API_SHARED_GROUP_LANDPLOTPOINT,
} from 'utils/apiList'

export const sharedFarmersApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'sharedFarmers/api',
  endpoints(builder) {
    return {
      fetchSharedGroups: builder.query({
        query({ page = 0, size = 100, search } = {}) {
          return {
            url: API_SHARED_GROUPS,
            params: {
              page,
              size,
              search: search || undefined,
            },
          }
        },
        keepUnusedDataFor: 300,
        transformResponse: (res) => {
          if (res?.data && !res?.items) {
            return {
              ...res.data,
              items: res.data.items || [],
              totalItems: res.data.totalItems ?? 0,
            }
          }
          return res
        },
        providesTags: ['SharedGroups'],
      }),
      fetchSharedGroupFarmers: builder.query({
        query({
          resourceId,
          page = 0,
          size = 10,
          search,
          status,
          vpstatus,
          vpStatus,
          groupCode,
          sortby,
          sortdir,
          isexport,
          startdate,
          enddate,
        } = {}) {
          const vpStatusValue = vpstatus || vpStatus || undefined
          return {
            url: `${API_SHARED_GROUP_FARMERS}/${resourceId}`,
            params: {
              page: isexport ? 0 : page,
              size: isexport ? 99999 : size,
              search: search || undefined,
              status: status || undefined,
              vpstatus: vpStatusValue,
              vpStatus: vpStatusValue,
              groupCode: groupCode || undefined,
              sortby: sortby || undefined,
              sortdir: sortdir || undefined,
              startdate: startdate || undefined,
              enddate: enddate || undefined,
            },
          }
        },
        keepUnusedDataFor: 300,
        transformResponse: (res) => {
          if (res?.data && !res?.items) {
            return {
              ...res.data,
              items: res.data.items || [],
              totalItems: res.data.totalItems ?? 0,
            }
          }
          return res
        },
        providesTags: (result, error, { resourceId }) => [
          { type: 'SharedGroupFarmers', id: resourceId },
        ],
      }),
      fetchSharedGroupFarmerSummary: builder.query({
        query({ resourceId, groupCode } = {}) {
          return {
            url: `${API_SHARED_GROUP_FARMER_SUMMARY}/${resourceId}`,
            params: {
              groupCode: groupCode || undefined,
            },
          }
        },
        keepUnusedDataFor: 300,
        transformResponse: (res) => res?.data || res,
      }),
      fetchSharedGroupManagement: builder.query({
        query({ resourceId, page = 0, size = 100, search } = {}) {
          return {
            url: `${API_SHARED_GROUP_MANAGEMENT}/${resourceId}`,
            params: {
              page,
              size,
              search: search || undefined,
            },
          }
        },
        keepUnusedDataFor: 300,
        transformResponse: (res) => {
          if (res?.data && !res?.items) {
            return {
              ...res.data,
              items: res.data.items || [],
              totalItems: res.data.totalItems ?? 0,
            }
          }
          return res
        },
      }),
      fetchSharedGroupManagementCount: builder.query({
        query({ resourceId, code } = {}) {
          return {
            url: `${API_SHARED_GROUP_MANAGEMENT_COUNT}/${resourceId}`,
            params: {
              code: code || undefined,
            },
          }
        },
        keepUnusedDataFor: 300,
        transformResponse: (res) => res?.data || res,
      }),
      fetchSharedFarmerDetail: builder.query({
        query({ resourceId, userId }) {
          return {
            url: `${API_SHARED_GROUP_FARMERS}/${resourceId}/${userId}`,
          }
        },
        keepUnusedDataFor: 300,
        transformResponse: (res) => res?.data || res,
      }),
      fetchSharedLandPlots: builder.query({
        query({ resourceId, userId, page = 0, size = 10, id, code, search } = {}) {
          return {
            url: `${API_SHARED_GROUP_LANDPLOT}/${resourceId}`,
            params: {
              userId: userId || undefined,
              page,
              size,
              id: id || undefined,
              code: code || undefined,
              search: search || undefined,
            },
          }
        },
        keepUnusedDataFor: 300,
        transformResponse: (res) => {
          if (res?.data && !res?.items) {
            return {
              ...res.data,
              items: res.data.items || [],
              totalItems: res.data.totalItems ?? 0,
            }
          }
          return res
        },
      }),
      fetchSharedLandPlotPoints: builder.query({
        query({ resourceId, code, userId, page = 0, size = 150 } = {}) {
          return {
            url: `${API_SHARED_GROUP_LANDPLOTPOINT}/${resourceId}`,
            params: {
              code,
              userId: userId || undefined,
              page,
              size,
            },
          }
        },
        keepUnusedDataFor: 300,
        transformResponse: (res) => res?.data || res,
      }),
    }
  },
})

export const {
  useFetchSharedGroupsQuery,
  useLazyFetchSharedGroupsQuery,
  useFetchSharedGroupFarmersQuery,
  useLazyFetchSharedGroupFarmersQuery,
  useFetchSharedGroupFarmerSummaryQuery,
  useLazyFetchSharedGroupFarmerSummaryQuery,
  useFetchSharedGroupManagementQuery,
  useLazyFetchSharedGroupManagementQuery,
  useFetchSharedGroupManagementCountQuery,
  useFetchSharedFarmerDetailQuery,
  useLazyFetchSharedFarmerDetailQuery,
  useFetchSharedLandPlotsQuery,
  useLazyFetchSharedLandPlotsQuery,
  useFetchSharedLandPlotPointsQuery,
  useLazyFetchSharedLandPlotPointsQuery,
} = sharedFarmersApiSlice
